import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";
import { appData, C, J } from "@/helpers/global";

export const MeetingService = {
    //List(callback, wait) {
    //    Ajax.Api(MethodType.Get, Enums.SERVICE.MEETING, null, wait).then((data) => {
    //        callback(data);
    //    });
    //},
    //ById(id, callback, wait) {
    //    Ajax.Api(MethodType.Get, Enums.SERVICE.MEETING + "/" + id, null, wait).then((data) => {
    //        callback(data);
    //    });
    //},
    Save(j, callback, wait) {
        return Ajax.Api(
            (j.id > 0 ? MethodType.Put : MethodType.Post),
            Enums.SERVICE.MEETING,
            j,
            wait
        ).then((data) => {
            if (typeof callback === "function") {
            callback(data);
            }
            return data;
        });
    },
    ChangeStudentOpinion(j, callback, wait) {
        Ajax.Api(MethodType.Put, Enums.SERVICE.MEETING + "/student-opinion", j, wait).then((data) => {
            callback(data);
        });
    },
    //Delete(id, callback) {
    //    const j = {};
    //    Ajax.Api(MethodType.Delete, Enums.SERVICE.MEETING + "/" + id, j).then((data) => {
    //        callback(data);
    //    });
    //},
    GetToken(channel, sub, callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.MEETING + "/token/" + channel + (sub != "" ? "/" + sub : ""), null, wait).then((data) => {
            callback(data);
        });
    },
    GetPresentationToken(channel, callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.MEETING + "/presentation-token/" + channel, null, wait).then((data) => {
            callback(data);
        });
    },
    GetRTMToken(channel, uid, callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.MEETING + "/rtm-token/" + channel + "/" + uid, null, wait).then((data) => {
            callback(data);
        });
    },
};